import { enablePatches } from "immer";
import z from "zod";

import { type MessageRequestUnauthorized } from "../../api-types";
import { response } from "../../http";

// Required in v6.
enablePatches();

export * from "./pageLocalStorageServer";

export const localStorage = z.record(z.string(), z.unknown());
export type LocalStorage = z.infer<typeof localStorage>;

// Initialize room

export const initializationFailed = z.object({
	error: z.string(),
	version: z.number(),
	localStorage: localStorage.nullable(),
});
export type InitializationFailed = z.infer<typeof initializationFailed>;
export const initializationFailedResponse = (
	requestHeaders: Headers,
	error: string | undefined,
	version: number,
	localStorage: LocalStorage | null
) =>
	response<InitializationFailed>(400, requestHeaders, {
		error: `invalid document` + error,
		version,
		localStorage,
	});

export const initializationSuccess = z.object({
	type: z.literal("success"),
	version: z.number(),
	localStorage,
});
type InitializationSuccess = z.infer<typeof initializationSuccess>;
const makeInitializationSuccess = (
	version: number,
	localStorage: LocalStorage
): InitializationSuccess => {
	return {
		type: "success",
		version,
		localStorage,
	};
};
export const initializationSuccessResponse = (
	requestHeaders: Headers,
	version: number,
	localStorage: LocalStorage
) => response(200, requestHeaders, makeInitializationSuccess(version, localStorage));

export const initializationRejectionResponse = (requestHeaders: Headers, version: number) =>
	response(200, requestHeaders, makeInitializationRejection(version));
export const initializationRejection = z.object({
	type: z.literal("rejected"),
	version: z.number(),
});
type InitializationRejection = z.infer<typeof initializationRejection>;
const makeInitializationRejection = (version: number): InitializationRejection => {
	return {
		type: "rejected",
		version,
	};
};
export type InitializationResponse =
	| InitializationFailed
	| InitializationSuccess
	| InitializationRejection
	| MessageRequestUnauthorized;
